export const meetingLabels = {
  /*
   * The two meeting nudges. Plain and factual — the page does the talking, and
   * every line here has to survive being read on a phone lock screen.
   * `{count}` is filled in by the caller; the two forms exist because a number
   * changes the verb in every one of these languages.
   */
  meeting_prep_kicker: {
    en: 'Preparation',
    nl: 'Voorbereiding',
    fr: 'Préparation',
  },
  meeting_prep_ready: {
    en: 'Your preparation is ready.',
    nl: 'Je voorbereiding staat klaar.',
    fr: 'Votre préparation est prête.',
  },
  meeting_prep_open_items_one: {
    en: '1 action item from your previous conversation is still open.',
    nl: '1 actiepunt uit jullie vorige gesprek staat nog open.',
    fr: "1 point d'action de votre conversation précédente est encore ouvert.",
  },
  meeting_prep_open_items_many: {
    en: '{count} action items from your previous conversation are still open.',
    nl: '{count} actiepunten uit jullie vorige gesprek staan nog open.',
    fr: "{count} points d'action de votre conversation précédente sont encore ouverts.",
  },
  /*
   * The other reading of the same moment: Wundo has nothing to write a
   * preparation from, so it asks for the little it needs instead.
   */
  meeting_prep_intake_teaser: {
    en: "Two minutes and you're prepared. I still need some context: answer a few targeted questions and I'll set up your preparation.",
    nl: 'Twee minuten en je bent voorbereid. Ik heb nog wat context nodig: beantwoord een paar gerichte vragen en ik zet je voorbereiding op.',
    fr: 'Deux minutes et vous êtes préparé. Il me faut encore un peu de contexte : répondez à quelques questions ciblées et je mets votre préparation en place.',
  },
  meeting_prep_intake_action: {
    en: 'Make your preparation',
    nl: 'Maak je voorbereiding',
    fr: 'Créer votre préparation',
  },
  meeting_prep_ready_action: {
    en: 'Open your preparation in Wundo',
    nl: 'Prep openen in Wundo',
    fr: 'Ouvrir la préparation dans Wundo',
  },
  meeting_report_kicker: {
    en: 'Report',
    nl: 'Verslag',
    fr: 'Compte rendu',
  },
  meeting_report_status: {
    en: 'Ready to share',
    nl: 'Klaar om te delen',
    fr: 'Prêt à partager',
  },
  meeting_report_ready: {
    en: 'Your report is ready.',
    nl: 'Je verslag staat klaar.',
    fr: 'Votre compte rendu est prêt.',
  },
  meeting_report_items_one: {
    en: '1 agreement recorded.',
    nl: '1 afspraak vastgelegd.',
    fr: '1 engagement noté.',
  },
  meeting_report_items_many: {
    en: '{count} agreements recorded.',
    nl: '{count} afspraken vastgelegd.',
    fr: '{count} engagements notés.',
  },
  meeting_report_ready_action: {
    en: 'Open your report in Wundo',
    nl: 'Verslag openen in Wundo',
    fr: 'Ouvrir le compte rendu dans Wundo',
  },
  /** What a meeting nobody gave a title is called on a card. */
  meeting_untitled: {
    en: 'Conversation',
    nl: 'Gesprek',
    fr: 'Conversation',
  },
  /*
   * Who the conversation is with, under the title. The names are joined with
   * commas and this word before the last one, so the line reads as a sentence
   * rather than a list. A number changes the noun in every one of these
   * languages, which is why the leftovers have two forms.
   */
  meeting_participants: {
    en: 'With {names}',
    nl: 'Met {names}',
    fr: 'Avec {names}',
  },
  meeting_participants_and: {
    en: 'and',
    nl: 'en',
    fr: 'et',
  },
  meeting_participants_others_one: {
    en: 'and 1 other',
    nl: 'en 1 andere',
    fr: 'et 1 autre',
  },
  meeting_participants_others_many: {
    en: 'and {count} others',
    nl: 'en {count} anderen',
    fr: 'et {count} autres',
  },
} as const satisfies Record<string, Record<string, string>>;
